'use client';
import React from 'react';
import CaretIcon from '../../atoms/icons/caret';
import LinkItem from './linkItem';
import { render } from 'storyblok-rich-text-react-renderer';
import { StoryblokComponent } from 'gatsby-source-storyblok';
import useHideOnSite from '../../../hooks/useLanguageFilter';
import { LinkWrapper } from '../../../utils/link';

const MainMenuItem = ({ nav, index, className, visibleIndex, setVisible }) => {
  const toggleVisibility = () => {
    setVisible(index);
  };

  const RichText = ({ document }) => {
    const r = render(document, {
      defaultBlokResolver: (name, props) => {
        const blok = { ...props, component: name };
        return <StoryblokComponent blok={blok} key={blok._uid} />;
      },
    });
    return r;
  };

  const trackingId = `main-menu-${nav.text}`;

  return useHideOnSite(nav.hide_on_site) ? null : (
    <div key={nav._uid + index} className="ml-0 static short:w-full">
      {nav.link_style === 'cta' ||
      !nav.sub_links ||
      nav.sub_links.length === 0 ? (
        nav.link_style === 'cta' ? (
          <LinkWrapper
            link={nav.link}
            className={` ${className} no-underline bg-yellow-60 hover:bg-yellow-40 hover:border-transparent font-medium pr-5 z-20 relative`}
            trackingId={trackingId}
          >
            {nav.text}
          </LinkWrapper>
        ) : (
          <LinkWrapper
            link={nav.link}
            className={`flex no-wrap no-underline group ${className} pr-5 ${
              visibleIndex === index ? 'border-black' : ''
            } font-medium z-20 relative`}
            trackingId={trackingId}
          >
            {nav.text}
          </LinkWrapper>
        )
      ) : (
        <button
          key={nav.link.cached_url}
          onClick={toggleVisibility}
          className={`flex no-wrap no-underline group ${className} ${
            !nav.sub_links || nav.sub_links.length === 0 ? 'pr-5' : ''
          } ${
            visibleIndex === index ? 'border-black' : ''
          } font-medium z-20 relative`}
          trackingId={trackingId}
        >
          <span className="pt-[0.1rem]">{nav.text}</span>
          {nav.sub_links && nav.sub_links.length > 0 && (
            <div className="">
              <CaretIcon />
            </div>
          )}
        </button>
      )}
      {nav.sub_links && nav.sub_links.length > 0 && (
        <div
          className={`absolute left-0 w-full h-fit ${
            visibleIndex === index
              ? 'visible inset-0 opacity-1 duration-300'
              : 'invisible -inset-full opacity-0 duration-300'
          }  transition-all  bg-yellow-7.5 rounded-b-lg `}
        >
          <div
            className={`w-full max-w-screen-xl mx-auto pt-32 pb-8 px-10 flex justify-between ${
              visibleIndex === index
                ? 'opacity-100 duration-100'
                : 'opacity-0 duration-100 delay-300'
            } transition-opacity  `}
          >
            <div className="w-1/2 max-w-[30rem] px-2">
              {RichText({ document: nav.link_description })}
            </div>
            <div className="w-1/2 flex mt-3">
              {nav.sub_links.map((item) => {
                return (
                  <div
                    key={item._uid}
                    className="w-1/2 short:w-1/3  px-4 max-w-[15rem]"
                  >
                    {item.component === 'link_item_group' ? (
                      <div key={item._uid} className="px-4 ">
                        {item.sub_links.map((i) => (
                          <LinkItem
                            item={i}
                            key={i._uid}
                            trackingParent={trackingId}
                          />
                        ))}
                      </div>
                    ) : (
                      <div key={item._uid} className="px-4">
                        <LinkItem
                          item={item}
                          key={item._uid}
                          trackingParent={trackingId}
                        />
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
      <div
        className={`inset-0 bg-transparent opacity-0 fixed -z-10 ${
          visibleIndex === index ? 'visible' : 'invisible'
        }`}
        onClick={() => setVisible(false)}
        role="button"
        onKeyUp={() => setVisible(false)}
        tabIndex={0}
        aria-label="Close menu item"
      ></div>
    </div>
  );
};

export default MainMenuItem;
